export default __webpack_public_path__ + "static/media/RR310_Frente.6c03285f.webp";